import React from 'react';
import { HeroPicture } from '@/components/HeroPicture';
import heroMobile from '@public/img/adviser/resources/marketing-toolkit/hero-mob.webp';
import heroTablet from '@public/img/adviser/resources/marketing-toolkit/hero-tab.webp';
import heroDesktop from '@public/img/adviser/resources/marketing-toolkit/hero-web.webp';

export const Hero = () => (
  <div>
    <div className="md:container md:mx-auto lg:grid lg:grid-cols-2 lg:gap-16 lg:items-center">
      <div className="px-6 md:px-0">
        <h1 className="text-[#006EB7] font-semibold text-xl mb-3 mt-6 lg:mt-0">
          Toolkit
        </h1>
        <h2 className="text-4xl md:text-5xl text-[#0C0D1A] font-semibold mb-6 md:w-[40rem] lg:w-auto lg:max-w-[30rem]">
          Marketing Toolkit for Advisers
        </h2>

        <p className="text-base text-[#373945] font-450 mb-6 lg:max-w-[30rem] xl:max-w-[35rem]">
          Designed to reach your target market, our marketing toolkit service offers a range of print and digital
          marketing resources to establish your presence and build your brand in the right places.
        </p>

        <div className="mt-8 lg:mt-10 flex flex-col md:flex-row md:gap-4 lg:gap-0 xl:gap-4">
          <div className="lg:flex lg:items-start gap-4 lg:w-[14rem] xl:w-auto">
            <div className="pb-4 md:pb-0">
              <a
                href="/professionals/resources/marketing-toolkit/request-toolkit"
                className="block md:inline-block default-button-primary-large w-full md:w-auto mx-auto md:ml-0 text-center lg:text-sm xl:text-base"
              >
                Request a toolkit
              </a>
            </div>
          </div>
          <div className="lg:flex lg:w-[18rem] xl:w-auto">
            <div>
              <button
                type="button"
                aria-label="Scroll to adviser toolkit section"
                onClick={() => {
                  const element = document.getElementById('adviser-toolkit');
                  element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
                className="block md:inline-block default-button-secondary-large w-full md:w-auto mx-auto md:ml-0 text-center lg:text-sm xl:text-base"
              >
                How the toolkit helps you
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full mt-8 lg:mt-0">
        <HeroPicture
          mobile={heroMobile}
          tablet={heroTablet}
          desktop={heroDesktop}
          alt="Marketing toolkit resources and materials for advisers"
          fill={false}
          sizes="(min-width: 1024px) 50vw, 100vw"
          className="object-cover md:rounded-xl"
        />
      </div>
    </div>
  </div>
);
